// My account: the first and last name each person sets, shown everywhere as the author.
export default {
  titre: 'My account',
  sousTitre: 'Your name in Orion: it signs what you create',
  prenom: 'First name',
  nom: 'Last name',
  adresse: 'Email address',
  vous: 'You appear as',
  enregistrer: 'Save',
  enregistre: 'Saved.',
  erreur: 'Your name could not be saved.',
  langue: 'Language',
}
